/**
 * Transaction process graph for bookings with split payments using Xendit:
 *   - default-booking-xendit
 */

export const transitions = {
  // When a customer makes a booking to a listing, a transaction is
  // created with the initial request-payment transition.
  REQUEST_PAYMENT: 'transition/request-payment',

  // Tell that the payment is confirmed.
  CONFIRM_PAYMENT: 'transition/confirm-payment',
};

export const states = {
  INITIAL: 'initial',
  PENDING_PAYMENT: 'pending-payment',
  DELIVERED: 'delivered',
};

export const graph = {
  // id is defined only to support Xstate format.
  id: 'default-booking-xendit/release-1',

  // This 'initial' state is a starting point for new transaction
  initial: states.INITIAL,

  // States
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.REQUEST_PAYMENT]: states.PENDING_PAYMENT,
      },
    },
    [states.PENDING_PAYMENT]: {
      on: {
        [transitions.CONFIRM_PAYMENT]: states.DELIVERED,
      },
    },
    [states.DELIVERED]: { type: 'final' },
  },
};

// Check if a transition is the kind that should be rendered
// when showing transition history (e.g. ActivityFeed)
export const isRelevantPastTransition = transition => {
  return [
    transitions.REQUEST_PAYMENT,
    transitions.CONFIRM_PAYMENT,
  ].includes(transition);
};

export const isCustomerReview = transition => false;
export const isProviderReview = transition => false;

// Check if the given transition is privileged.
export const isPrivileged = transition => {
  return [transitions.REQUEST_PAYMENT].includes(transition);
};

// Check when transaction is completed
export const isCompleted = transition => {
  return [transitions.CONFIRM_PAYMENT].includes(transition);
};

// Check when transaction is refunded
export const isRefunded = transition => false;

export const statesNeedingProviderAttention = [];
export const statesNeedingCustomerAttention = [states.PENDING_PAYMENT];
